import { BaseMarkerFactory } from "../../../_shared/interfaces/maps/base-marker-factory";
import { FuelLevel } from "../models/fuel-level.model";

export class FuelLevelMarkerFactory extends BaseMarkerFactory {

  protected override createMarkerDiv(data: FuelLevel): HTMLDivElement {
    const markerDiv = document.createElement('div');

    let color: string = '#ee2737'
    let type: string = 'normal';
    if (data.fuelLevel! <= data.lowFuelLevelThreshold) {
      color = '#FF7F00';
      type = 'warning';
      markerDiv.style.setProperty('--cluster-color', color);
      markerDiv.className = "marker-pulsate";
    }

    const direction: number = !data.direction ? 1 : data.direction;
    markerDiv.dataset['type'] = type;
    markerDiv.innerHTML = `
    <svg style="transform: rotate(${direction}deg); transform-origin: center;" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 12C0 5.37258 5.37258 0 12 0V0C18.6274 0 24 5.37258 24 12V12C24 18.6274 18.6274 24 12 24V24C5.37258 24 0 18.6274 0 12V12Z" fill="${color}"/>
      <path d="M6.16788 17.777C6.34901 17.9816 6.63519 18.0537 6.89009 17.9585L12.0002 16.0438L17.1098 17.9581C17.3526 18.0486 17.6247 17.9877 17.8063 17.8044C17.8152 17.7954 17.8231 17.7865 17.832 17.7766C18.0132 17.5729 18.0514 17.2769 17.9291 17.0318L12.5898 6.36625C12.4773 6.14235 12.249 6.00047 12.0002 6C11.7514 5.99953 11.5249 6.14235 11.4106 6.36625L6.07124 17.0328C5.94846 17.2774 5.98674 17.5734 6.16788 17.777Z" fill="white"/>
    </svg>`;

    return markerDiv;
  }

  protected override createTitle(data: any): string {
    return '';
  }
}